import axios, { AxiosInstance, AxiosRequestConfig, AxiosPromise, AxiosResponse } from 'axios'
import { getMd5Token } from '../auth'
import cache from './http-cache'
import { useMessage } from '@haohan/clw-hooks'
import { transformUrlOnTemplatePreview } from '../template'
import { getCurrentLocale } from '../i18n'
import { t } from '../use-i18n/locales/index'
/**
 * 第三方API请求封装
 */
const BASE_URL = '.'
const API_CACHE_TIME = 1000
class HttpRequest {
  constructor(public baseUrl: string) {
    this.baseUrl = baseUrl
  }
  public request(options: AxiosRequestConfig): AxiosPromise {
    let instance
    if (options.responseType === 'blob') {
      instance = axios.create()
    } else {
      instance = axios.create({
        adapter: cache({ time: API_CACHE_TIME })
      })
    }

    options = this.mergeConfig(options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
  private interceptors(instance: AxiosInstance, url?: string) {
    instance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        if (!config.headers) {
          // menuId 为了方便日志记录时使用
          config.headers = { authorization: '', menuId: '' }
        }
        const tokenInfo = getMd5Token()
        if (tokenInfo) {
          config.headers.authorization = tokenInfo.token
          config.headers.timestamp = tokenInfo.timestamp
          config.headers.sign = tokenInfo.sign
        }
        // 进行模板预览处理
        config.url = transformUrlOnTemplatePreview(config.url)
        // i18n国际化处理
        config.headers['Accept-Language'] = getCurrentLocale()
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    instance.interceptors.response.use(
      (res: AxiosResponse) => {
        return res
      },
      (error) => {
        console.log('API第三方接口请求错误', error)
        // 获取异常状态码
        const { status, tag } = error.response.data
        let message = ''
        if (status === 400) {
          message = t('global.interfaceDefinitionErrorTip')
        } else if (status === 502) {
          message = t('global.interfaceCallErrorTip')
        } else {
          message = t('global.interfaceUndefinedErrorTip')
        }
        useMessage({ ...error.response.data, message, tag: '' })
        return Promise.reject(error)
      }
    )
  }
  private mergeConfig(options: AxiosRequestConfig): AxiosRequestConfig {
    return Object.assign({ baseURL: this.baseUrl }, options)
  }
}

export const interfaceService = new HttpRequest(BASE_URL)
